const initialState = {
  user: JSON.parse(localStorage.getItem('gfUser')),
  token: localStorage.getItem('gfToken'),
  refreshToken: localStorage.getItem('gfRefreshToken'),
  err: null,
  loading: false,
  success: false,
  sessionStatus: localStorage.getItem('sessionStatus') || null,
}

export default function authReducer(state = initialState, action) {
  if (process.env.NODE_ENV !== 'production') {
    console.log(action)
  }
  const { type, err, data } = action

  switch (type) {
    case 'SET_USER':
      return {
        ...state,
        user: action.user,
      }

    case 'SET_TOKEN':
      localStorage.setItem('gfToken', action.token)
      localStorage.setItem('gfRefreshToken', action.refreshToken)
      return {
        ...state,
        token: action.token,
        refreshToken: action.refreshToken,
      }

    case 'LOGOUT':
      localStorage.removeItem('gfToken')
      localStorage.removeItem('gfRefreshToken')
      localStorage.removeItem('gfUser')
      localStorage.removeItem('sessionStatus')
      return initialState

    case 'REGISTER_USER':
    case 'LOGIN':
    case 'FORGOT_PASSWORD':
    case 'RESET_PASSWORD':
      return {
        ...state,
        loading: true,
        err: null,
        success: false,
      }

    case 'REGISTER_USER_SUCCESS':
      return {
        ...state,
        loading: false,
        err: null,
      }

    case 'FORGOT_PASSWORD_SUCCESS':
    case 'RESET_PASSWORD_SUCCESS':
      return {
        ...state,
        loading: false,
        err: null,
        success: true,
      }

    case 'GET_ACCOUNT_INFO_SUCCESS':
      return {
        ...state,
        user: {
          ...state.user,
          account: data,
        },
      }

    case 'LOGIN_SUCCESS':
      const user = {
        account: data.account,
        profile: data.profile,
        telco: data.telco,
      }
      const token = data.accessToken
      const refreshToken = data.refreshToken

      localStorage.setItem('gfToken', token)
      localStorage.setItem('gfRefreshToken', refreshToken)
      localStorage.setItem('gfUser', JSON.stringify(user))

      return {
        ...state,
        loading: false,
        err: null,
        user,
        token,
        refreshToken: refreshToken,
      }

    case 'REGISTER_USER_FAILURE':
    case 'FORGOT_PASSWORD_FAILURE':
    case 'LOGIN_FAILURE':
    case 'RESET_PASSWORD_FAILURE':
      return {
        ...state,
        loading: false,
        err,
      }

    case 'RESET_AUTH_STATE':
      return {
        ...state,
        loading: false,
        err: null,
        success: false,
      }

    case 'VALIDATE_SESSION':
      localStorage.setItem('sessionStatus', 'validating')

      return {
        ...state,
        sessionStatus: 'validating',
        loading: true,
      }
    case 'VALIDATE_SESSION_SUCCESS':
      localStorage.setItem('sessionStatus', 'success')

      return {
        ...state,
        sessionStatus: 'success',
        loading: false,
      }
    case 'VALIDATE_SESSION_FAILED':
      localStorage.setItem('sessionStatus', 'failed')
      localStorage.setItem('logoutToken', data)

      return {
        ...state,
        sessionStatus: 'failed',
        loading: false,
      }

    default:
      return state
  }
}
